import type { SessionAccessMode } from '../session-mode';
import { normalizeSessionAccessMode } from '../session-mode';

/** Small, shared segmented control used by all connection entry points. */
export function bindSessionModePicker(
  id: string,
  onChange?: (mode: SessionAccessMode) => void,
): void {
  const root = document.getElementById(id);
  if (!root) return;
  const buttons = Array.from(root.querySelectorAll<HTMLButtonElement>('[data-session-mode]'));
  if (!buttons.length) return;
  const apply = (value: unknown): SessionAccessMode => {
    const mode = normalizeSessionAccessMode(value);
    root.dataset.mode = mode;
    for (const button of buttons) {
      const selected = button.dataset.sessionMode === mode;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-pressed', String(selected));
    }
    return mode;
  };
  apply(root.dataset.mode);
  for (const button of buttons) {
    button.addEventListener('click', () => {
      // 即使调用方不需要回调，也必须先更新当前模式和按钮状态。
      const mode = apply(button.dataset.sessionMode);
      onChange?.(mode);
    });
  }
}

export function readSessionMode(id: string): SessionAccessMode {
  const root = document.getElementById(id);
  return normalizeSessionAccessMode(root?.dataset.mode);
}

export function setSessionMode(id: string, mode: SessionAccessMode): void {
  const root = document.getElementById(id);
  if (!root) return;
  const normalized = normalizeSessionAccessMode(mode);
  root.dataset.mode = normalized;
  for (const button of root.querySelectorAll<HTMLButtonElement>('[data-session-mode]')) {
    const selected = button.dataset.sessionMode === normalized;
    button.classList.toggle('active', selected);
    button.setAttribute('aria-pressed', String(selected));
  }
}
